import t from "./_Symbol.js";
import f from "./_arrayMap.js";
import m from "./isArray.js";
import p from "./isSymbol.js";
var s = 1 / 0, i = t ? t.prototype : void 0, n = i ? i.toString : void 0;
function y(r) {
  if (typeof r == "string")
    return r;
  if (m(r))
    return f(r, y) + "";
  if (p(r))
    return n ? n.call(r) : "";
  var o = r + "";
  return o == "0" && 1 / r == -s ? "-0" : o;
}
export {
  y as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_baseToString.js
// module id = 1450
// module chunks = 41